import React, { useEffect, useState } from 'react'
import ModalComp from 'components/ModalComp'
import useLoading from 'hooks/useLoading'
import { Col, Descriptions, Divider, Row } from 'antd'
import { useSelector } from 'react-redux'
import { RootState } from 'redux/store'
import usePagination from 'hooks/usePagination'
import { IAsset } from 'models/Assets'
import useDetails from '../hooks/useDetails'
import InputComp from 'components/InputComp'
import useForm from 'hooks/useForm'
import ButtonIcon from 'components/ButtonComp'
import { faEdit } from '@fortawesome/free-solid-svg-icons'
import { getKmFormat } from 'libs/functions'
import TabsComp from 'components/TabsComp'
import AditionalInfo from './AditionalInfo'

type Props = {
    onClose: () => void;
    hookAssets: ReturnType<typeof usePagination<IAsset>>;
}

const DetailsModal: React.FC<Props> = ({
    onClose = () => { },
    hookAssets
}: Props) => {
    const { selectedItem } = hookAssets;
    const { formatValue, getLabel, isHidden, isContained, getNewValues } = useDetails();
    const items = useSelector((state: RootState) => state.inventory.its);
    const { isLoading } = useLoading({ defaultLoading: true });
    const hookForm = useForm({});
    const [activeKey, setActiveKey] = useState("info-tab");

    const [entries, setEntries] = useState<[string, any][]>([]);

    useEffect(() => {
        setEntries(selectedItem ? Object.entries(selectedItem) : []);
    }, [items, selectedItem]);

    return (
        <ModalComp
            title={<h3>{selectedItem?.description} {getKmFormat(selectedItem?.km)}</h3>}
            isOpen={true}
            // loading={isLoading}
            // width={{ xs: '100%', sm: '90%', md: '100%' }}
            onClose={onClose}
        >
            <TabsComp
                defaultActiveKey={activeKey}
                activeKey={activeKey}
                onChange={(key) => setActiveKey(key)}
                items={[
                    {
                        label: "Información",
                        key: "info-tab",
                        children: <Descriptions
                            // extra={[
                            //     <ButtonIcon icon={faEdit} name='Editar' variant='outline-primary' disabled />
                            // ]}
                            // title="Información"
                            bordered
                            column={{ xs: 1, sm: 2, md: 3, lg: 3, xl: 4, xxl: 4 }}
                            items={entries
                                .filter(([keyItem]) => !isHidden(keyItem) && isContained(keyItem) && !getNewValues(keyItem) )
                                .map(([keyItem, valueItem]) => {
                                    const label = getLabel(keyItem);
                                    const value = formatValue(valueItem, keyItem);
                                    const span = { xs: 1, sm: 2, md: 3, lg: 3, xl: 2, xxl: 2 };
                                    return { label, children: value, span };
                                })}
                        />
                    }, 
                    {
                        label: "Información adicional",
                        key: "aditional-info",
                        children:   <AditionalInfo
                                        entries={entries}
                                        asset_id={selectedItem?.id || 0}
                                        project_id={ selectedItem?.project_id || 0 }
                                        onClose={onClose}
                                        hookAssets={hookAssets}
                                    />
                    }, 
                    {
                        label: "Fotografías",
                        key: "pics-tab",
                        children: <div style={{ minHeight: "50vh" }}>
                        </div>
                    }
                ]}
            />

            {/* {selectedItem?.extra && (
                <>
                    <Divider orientation="left">Atributos adicionales</Divider>
                    <Row gutter={24}>
                        {headersExtra.map((key, index) => {
                            const label = getLabel(key);
                            const value = formatValue(elementsExtra[index], key);
                            return (
                                <Col key={key} xs={2} sm={4} md={6} lg={6} xl={12}>
                                    <FormIcon title={label} name={key} defaultValue={value}
                                        value={formExtra[key]} handleChange={handleChangeExtra} />
                                </Col>
                            );
                        })}
                    </Row>
                </>
            )} */}
        </ModalComp>
    )
}

export default DetailsModal